
import { createContext, useContext } from "react";
import useWebSocket, { ReadyState } from "react-use-websocket"


const WSContext = createContext();
const WS_URL = process.env.REACT_APP_WS_URL;


export const WSProvider = ({ children }) => {

  const { sendJsonMessage, lastJsonMessage, readyState,  } = useWebSocket(
    WS_URL,
    {
      share: false,
      shouldReconnect: () => true,
    },
  )

  const message = async (message) => {
    sendJsonMessage(message);
  }

  return (
    <WSContext.Provider
      value={{
        message,
        lastJsonMessage,
        readyState,
      }}
    >
      {children}
    </WSContext.Provider>
  );

}

export const useWS= () => {
    const context = useContext(WSContext);
    if (!context) {
        throw new Error("useWS must be used within a WSProvider");
      }
      return context;   
};